export default function Hero() {
    return (
        <section className="hero">
            <div className="container">
                <h1>Shorten Your URLs with Style</h1>
                <p>Transform long, unwieldy URLs into clean, shareable links. Perfect for social media, emails, and anywhere you need to share links.</p>
            </div>
        </section>
    )
}